export const HMDBPLink = (hmdbp) => <a href={"https://hmdb.ca/proteins/" + hmdbp.value} target="_blank" rel="noopener noreferrer"> {hmdbp.value} </a>
